import React, { useState, useEffect, useContext } from 'react';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import ProjectType from 'src/models/ProjectType';
import { SelectItem } from 'src/models/common/SelectItem';
import { Form, AnyObject } from 'react-final-form';
import State from 'src/models/State';
import arrayMutators from 'final-form-arrays';
import Textbox from 'src/components/controls/forms/redesign/FormTextbox';
import Select from 'src/components/controls/forms/redesign/FormFilterSelect';
import County from 'src/models/County';
import TagContainer from '../counties/TagContainer';
import Office from 'src/models/Office';
import User from 'src/models/User';
import Project from 'src/models/Project';
import { useDispatch, useSelector } from 'react-redux';
import Client from 'src/models/Client';
import PagedResultSet from 'src/models/common/PagedResultSet';
import Button from '../controls/forms/redesign/FormButton';
import { IRootState } from 'src/reducers';
import actions from 'src/actions';
import { LandSystem } from 'src/models/LandSystem';
import { FormApi } from 'final-form';

interface IEditProjectPageRedesignStateProps {
    showDialog: (dialogName: string) => void;
    hideDialog: () => void;
    setRefreshProjectData: (refresh: boolean) => void;
    onPageUpdated: () => void;
    handleLandSystemLogic: (landSystem: LandSystem) => void;
}

const EditProjectPageRedesign = (props: IEditProjectPageRedesignStateProps) => {
    const restrictedLandSystems: LandSystem[] = [
        LandSystem.RightOfWay
    ];

    const dispatch = useDispatch();
    const { get, response } = useFetch();
    const { project } = useSelector((state: IRootState) => state);

    const appContext = useContext<IAppContextState>(AppContext);
    const [projectManagerId, setProjectManagerId] = useState<number>(undefined);
    const [managingOfficeId, setManagingOfficeId] = useState<number>(undefined);
    const [projectData, setProjectData] = useState<Project>(undefined);
    const [formValues, setFormValues] = useState<{}>(undefined);
    const [users, setUsers] = useState<User[]>([]);
    const [userSelectList, setUserSelectList] = useState<SelectItem[]>([]);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [stateCounties, setStateCounties] = useState<PagedResultSet<County>>(undefined);
    const [projectTypes, setProjectTypes] = useState<ProjectType[]>(undefined);
    const [tractTypes, setTractTypes] = useState<SelectItem[]>(undefined);
    const [offices, setOffices] = useState<Office[]>(undefined);
    const [restrictTractType, setRestrictTractType] = useState<boolean>(false);

    useEffect(() => {
        getProjectData();
        getUsers();
        getStates();
        getProjectTypes();
        getOffices();
        getTractTypes();
    }, []);

    useEffect(() => {
        if (!!users && users.length > 0) {
        setUserSelectList(users.map((u: User) => {return { id: u.id, name: u.firstName + ' ' + u.lastName}; } ));
        const selectPM = users
        ? users?.filter((p: User) => p?.role?.id === 2).map((p: User) => new SelectItem(p.id, `${p.firstName} ${p.lastName}`))
        : undefined;
        console.log(selectPM);
        }
    }, [users]);

    useEffect(() => {
        if (!!projectData) {
            getStatesCounties(projectData.state?.id);
            setManagingOfficeId(projectData.managingOfficeId);
            setProjectManagerId(projectData.pcapmId);
        }
    }, [projectData]);

    useEffect(() => {
        if (project.createProjectLoading === false && projectData === undefined) {
            getProjectData();
        }
        if (project.showPageUpdated === true) {
            props.onPageUpdated();            
        }
    }, [project]);

    useEffect(() => {
        if (formValues === undefined && project.createProjectLoading === false && projectData !== undefined && !!stateCounties) {
            setFormValues({
                ...projectData,
                managingOfficeId: managingOfficeId,
                projectManagerId: projectManagerId,
                county: selectStateCounties && selectStateCounties.length === 1 ? selectStateCounties[0].id : new SelectItem(1, 'Select a County')
            });
        }
    }, [stateCounties, projectData]);

    useEffect(() => {
        const typedVals = formValues as unknown as Project;
        if (typedVals?.landSystemId !== undefined && typedVals?.landSystemId !== null) {
            props.handleLandSystemLogic(typedVals.landSystemId);
        }
    }, [formValues]);

    const getProjectData = async () => {
        const result = await get(`v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}`);

        if (response.ok) {
            setProjectData(result);
        } else {
            console.log('Unable to retrieve Project data');
        }
    };

    const getUsers = async () => {
        const result = await get(`/v1.0/users`);

        if (response.ok) {
            setUsers(result.items);
        } else {
            console.log('Unable to retrieve Users data.');
        }
    };
/* 
    const getTSDIUsers = async () => {
        const result = await get(`/v1.0/users`);

        if (response.ok) {
            setUsers(result.items);
        } else {
            console.log('Unable to retrieve Users data.');
        }
    }; */

    const getStates = async () => {
        const result = await get(`/v1.0/states`);

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to retrieve States data.');
        }
    };

    const getProjectTypes = async () => {
        const result = await get(`/v1.0/ProjectTypes`);

        if (response.ok) {
            setProjectTypes(result);
        } else {
            console.log('Unable to retrieve Project Types.');
        }
    };

    const getTractTypes = async () => {
        const result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/tract-types`);

        if (response.ok) {
            setTractTypes(result);
        } else {
            console.log('Unable to retrieve Tract Types');
        }
    };

    const getOffices = async () => {
        const result = await get(`/v1.0/OfficeLocations`);

        if (response.ok) {
            setOffices(result);
        } else {
            console.log('Unable to retrieve Office Locations.');
        }
    };

    const getStatesCounties = async (id: number) => {
        const result = await get(`/v1.0/States/${id}/counties`);

        if (result) {
            setStateCounties(result);
        } else {
            console.log('Unable to retrieve the Counties for selected State.');
        }
    };

    const selectedState = (id: number) => {
        getStatesCounties(id);
    };

    const updateProject = (data: Project) => {
        // if (isDirty) {
        dispatch(actions.project.updateProject(data));
        // }
    };

    const onSubmit = (projectForm: Project) => {
        projectForm.client = projectForm.client ? projectForm.client : new Client();
        projectForm.client.id = appContext.clientNumber;

        if (projectForm.id) {
            updateProject(projectForm);
            props.onPageUpdated();
        }
    };

    const validate = (projectForm: AnyObject) => {
        const errors: AnyObject = {};

        if (!projectForm.name) {
            errors.name = 'Name is Required';
        }

        if (!projectForm.landSystemId) {
            errors.landSystemId = 'Land System is required';
        }

        if (!projectForm.state || !projectForm.state.id) {
            errors.state = {};
            errors.state.id = 'State is required';
        }

        if (!projectForm.managingOfficeId) {
            errors.managingOfficeId = 'Office is required';
        }

        if (!projectForm.tractTypeId) {
            errors.tractTypeId = 'Tract Type is required';
        }

        return errors;
    };

    const checkRestriction = (e: LandSystem, form: FormApi<{}>) => {
        // TODO: This won't work consistently if we start restricting other Land Systems.
        const restricted = restrictedLandSystems.includes(e);
        setRestrictTractType(restricted);
        if (restricted) {
            let tractTypeValue = tractTypes.find(tt => tt.name === 'Surface Tract')?.id;
            form.change('tractTypeId', tractTypeValue);
        }
        props.handleLandSystemLogic(e);
    };

    const selectProjectTypes = projectTypes ? projectTypes.map((type: ProjectType) => new SelectItem(type.id, type.name)) : undefined;

    const selectLandSystems = [
        new SelectItem(1, 'Jeffersonian'),
        new SelectItem(3, 'West Texas'),
        new SelectItem(4, 'East Texas'),
        new SelectItem(2, 'Eastern'),
        new SelectItem(1001, 'Right of Way')
    ];

    const selectStates = states ? states?.items?.map((state: State) => new SelectItem(state.id, state.name)) : undefined;
    const selectStateCounties = stateCounties ? stateCounties?.items?.map((c: County) => new SelectItem(c.id, c.name)) : undefined;
    const managingOfficesList = offices ? offices?.map((office: Office) => new SelectItem(office.id, office.name)) : undefined;

/*     const selectPM = users
        ? users?.filter((p: User) => p?.role?.id === 2).map((p: User) => new SelectItem(p.id, `${p.firstName} ${p.lastName}`))
        : undefined; */

    return (
        <>
            <div>
                <Form
                    onSubmit={onSubmit}
                    mutators={{ ...arrayMutators }}
                    validate={validate}
                    initialValues={formValues && formValues}
                    render={({ handleSubmit, form }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <Textbox label="Project Name" name="name" style={{ width: '150px' }} />
                                    <Select
                                        label="Land System"
                                        name="landSystemId"
                                        items={selectLandSystems}
                                        defaultOption="Select Land System"
                                        onChange={(e) => checkRestriction(e as number as LandSystem, form)}
                                        style={{ width: '160px', marginLeft: '2rem' }}
                                    />
                                    <Select
                                        label="Project Type"
                                        name="projectType.id"
                                        items={selectProjectTypes}
                                        defaultOption="Select Project Type"
                                        style={{ width: '180px', marginLeft: '2rem' }}
                                    />
                                    <Select
                                        label="Tract Type"
                                        name="tractTypeId"
                                        items={tractTypes}
                                        defaultOption="Select Tract Type"
                                        style={{ width: '150px', marginLeft: '2rem' }}
                                        isDisabled={restrictTractType || projectData?.tractTypeId > 0}
                                    />
                                    <Select
                                        label="Managing Office"
                                        name="managingOfficeId"
                                        items={managingOfficesList}
                                        style={{ width: '160px', marginLeft: '2rem' }}
                                    />
                                    <Select
                                        label="Project Manager"
                                        name={'projectManagerId'}
                                        items={userSelectList}
                                        style={{ width: '160px', marginLeft: '2rem' }}
                                    />
                                    {/* <Select label="Originating Manager" name="pcapmId" items={selectPM} style={{ width: '160px', marginLeft: '2rem' }} /> */}
                                    {/* <Select label="Originating Office" name="pcapmId" items={selectPM} style={{ width: '160px', marginLeft: '2rem' }} /> */}
                                    <div style={{ display: 'flex', gap: '2rem', width: '98%' }}>
                                        <Select
                                            label="State"
                                            name="state.id"
                                            items={selectStates}
                                            defaultOption="Select State"
                                            onChange={(e) => selectedState(e as number)}
                                            style={{ width: '200px' }}
                                        />

                                        <TagContainer
                                            label="Counties"
                                            isTagCreatable={false}
                                            fieldArrayName="counties"
                                            fieldAddArrayName="addCounties"
                                            fieldDeleteArrayName="deleteCounties"
                                            initialValueName="county"
                                            form={form}
                                            selectTags={selectStateCounties ? selectStateCounties : new Array<SelectItem>()}
                                        />
                                    </div>

                                    <br />
                                    <div style={{ marginTop: '1rem', display: 'flex', gap: '3rem' }}>
                                        <Button type="submit" intent="primary" text="Save Project" />
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                />
            </div>
        </>
    );
};

export default EditProjectPageRedesign;


// WEBPACK FOOTER //
// ./src/components/project/EditProjectPage.redesign.tsx